export default __webpack_public_path__ + "static/media/piloto_corner.d6cfa632.png";